import { FC, useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Grid, CircularProgress, IconButton, Typography, Box, TableRow, TableCell } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { moneyCL } from "../../../toolbox/helpers/money-helpers";
import { useRenditionBuildingStore } from "../../../hooks/useRenditionBuildingStore";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import WarningIcon from '@mui/icons-material/Warning'
import {
    MonetizationOn,
    Percent,
    AccountBalanceWallet,
    WarningAmber,
    History,
    Paid,
    Calculate
} from '@mui/icons-material'
interface ModalBuildingDepartmentProps {
    open: boolean;
    closeModal: () => void;
    renditionSelected: { id: string } | null;
}
const columns = [
    { type: "text", field: "description", label: "DEPARTAMENTO", align: "center" },
    { type: "text", field: "alicuota", label: "ALICUOTA", align: "center", format: (row) => `${row.alicuota} %` },
    {
        type: "text", field: "alicuota_amount", label: "MONTO ALICUOTA", align: "right",
        format: (row) => moneyCL(row.alicuota_amount)
    },
    {
        type: "text",
        field: "amount_individual",
        label: "TOTAL INDIVIDUAL",
        align: "right",
        format: (row) => moneyCL(row.amount_individual),
    },
    {
        type: "text",
        field: "amount_mes",
        label: "DEUDA DEL MES",
        align: "right",
        format: (row) => moneyCL(row.amount_mes),
    },
    {
        type: "text",
        field: "previous_month_balance",
        label: "DEUDA DEL MES ANTERIOR",
        align: "right",
        format: (row) => moneyCL(row.previous_month_balance),
    },
    {
        type: "text",
        field: "favor_month_balance",
        label: "SALDO A FAVOR",
        align: "right",
        format: (row) => moneyCL(row.favor_month_balance),
    },
    {
        type: "text",
        field: "total_pay",
        label: "TOTAL A PAGAR",
        align: "right",
        format: (row) => moneyCL(row.total_pay),
    },
    // {
    //     type: "text",
    //     field: "total_paid",
    //     label: "TOTAL PAGADO",
    //     align: "center",
    //     format: (row) => moneyCL(row.total_paid),
    // },
    // {
    //     type: "text",
    //     field: "amount_balance",
    //     label: "BALANCE MES",
    //     align: "center",
    //     format: (row) => moneyCL(row.amount_balance),
    // },
    { type: "detail", field: "detail", label: "", align: "center" },
];

export const ModalBuildingDepartment: FC<ModalBuildingDepartmentProps> = ({
    open,
    closeModal,
    renditionSelected
}) => {
    const { getDetailRendicionAll, getRenditionDetailPDF, renditionBuildings } = useRenditionBuildingStore();
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [formattedData, setFormattedData] = useState<any[]>([]);
    const [warningMessage, setWarningMessage] = useState<string | null>(null);

    const totals = (() => {
        const result = formattedData.reduce((acc, item) => {
            acc.previous_month_balance += item.previous_month_balance
            acc.alicuota += item.alicuota
            acc.alicuota_amount += item.alicuota_amount
            acc.favor_month_balance += item.favor_month_balance
            acc.amount_individual += item.amount_individual
            acc.amount_mes += item.amount_mes
            acc.total_pay += item.total_pay
            acc.total_paid += item.total_paid
            acc.amount_balance += item.amount_balance
            return acc
        }, {
            previous_month_balance: 0,
            alicuota: 0,
            alicuota_amount: 0,
            favor_month_balance: 0,
            amount_individual: 0,
            amount_mes: 0,
            total_pay: 0,
            total_paid: 0,
            amount_balance: 0
        })

        return {
            ...result
        }
    })()

    useEffect(() => {
        if (renditionSelected?.id) {
            getDataDepartments(renditionSelected.id);
        }
    }, [renditionSelected]);

    const formatRenditionData = (dataArray) => {
        if (!Array.isArray(dataArray)) return [];

        return dataArray.map((data) => ({
            description: data.department.department_name,
            building: data.department.building,
            subtotal: data.data.general.total,
            amount_individual: parseInt(data.data.individual.total),
            amount_mes: parseInt(data.data.subtotal),
            previous_month_balance: parseFloat(data.data.saldoMesAnterior),
            favor_month_balance: parseInt(data.data.saldoFavorMesAnterior),
            total_pay: parseFloat(data.data.total_pagar),
            total_paid: parseInt(data.data.total_pagado),
            iddepartment: data.department.iddepartment,
            amount_balance: parseInt(data.data.balanceMes),
            alicuota: parseFloat(data.data.alicuota),
            alicuota_amount: parseInt(data.data.alicuota_amount),
            total_building: parseInt(data.data.edificio.total),
            total_general_spents: data.data.total_general_spents,
            background: data.data.background,
            message_warning: data.data.message_warning,
        }));
    };

    const getDataDepartments = async (id) => {
        try {
            setLoading(true);
            const response = await getDetailRendicionAll({ idreport_building: id });

            if (response && Array.isArray(response)) {
                const formatted = formatRenditionData(response);
                setFormattedData(formatted);
            }
        } catch (error) {
            console.error("Error al obtener la rendición:", error);
        } finally {
            setLoading(false);
        }
    };

    const onHelper = async (rowSelected) => {
        setDownloading(true);
        try {
            const parsedId = renditionSelected?.id ? parseInt(renditionSelected.id, 10) : 0;
            const response = await getRenditionDetailPDF(parsedId, rowSelected.iddepartment);
            if (response !== false) {
                const blob = new Blob([response], { type: "application/pdf" });
                const bloblURL = URL.createObjectURL(blob);
                window.open(bloblURL, "_blank");
            }
        } finally {
            setDownloading(false);
        }
    };

    const finalRow = (
        <TableRow>
            <TableCell colSpan={1} align="center" style={{ background: "#89B2DF", color: "#fff" }}>
                <strong>TOTAL</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{parseFloat(totals.alicuota.toFixed(4))}%</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.alicuota_amount)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.amount_individual)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.amount_mes)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.previous_month_balance)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.favor_month_balance)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.total_pay)}</strong>
            </TableCell>
            {/* <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.total_paid)}</strong>
            </TableCell>
            <TableCell align="right" style={{ background: "#D8E8F7" }}>
                <strong>{moneyCL(totals.amount_balance)}</strong>
            </TableCell> */}
            <TableCell style={{ background: "#D8E8F7" }}></TableCell>
        </TableRow>
    )

    const indicators = [
        {
            label: 'Gastos comunes registrados',
            value: moneyCL(renditionBuildings[0]?.amount_general || 0),
            bg: '#E3F2FD',
        },
        {
            label: 'Alicuota asignada',
            value: `${parseFloat(renditionBuildings[0]?.total_alicuota).toFixed(4)}%`,
            bg: '#FFF3E0',
        },
        {
            label: 'Alicuota ejecutada',
            value: moneyCL(totals.alicuota_amount),
            bg: '#E8F5E9',
        },
        {
            label: 'Gastos individuales registrados',
            value: moneyCL(renditionBuildings[0]?.amount_individual || 0),
            bg: '#F3E5F5',
        },
        {
            label: 'Deuda del mes',
            value: moneyCL(
                (totals.alicuota_amount || 0) +
                (renditionBuildings[0]?.amount_individual || 0)
            ),
            bg: '#FFEBEE',
        },
        {
            label: 'Deuda del mes anterior',
            value: moneyCL(
                (totals.previous_month_balance || 0)
            ),
            bg: '#FFEBEE',
        },
        {
            label: 'Total de la rendición',
            value: moneyCL(
                (totals.total_pay || 0)
            ),
            bg: '#FFEBEE',
        },
    ]

    const indicatorCards = [
        {
            icon: <MonetizationOn sx={{ fontSize: 32, color: '#4caf50' }} />,
            label: 'Gastos comunes registrados',
            value: indicators[0]?.value || '0',
            bg: '#E8F5E9'
        },
        {
            icon: <Percent sx={{ fontSize: 32, color: '#1976d2' }} />,
            label: 'Alicuota asignada',
            value: indicators[1]?.value || '0',
            bg: '#E3F2FD'
        },
        {
            icon: <AccountBalanceWallet sx={{ fontSize: 32, color: '#ff9800' }} />,
            label: 'Alicuota ejecutada',
            value: indicators[2]?.value || '0',
            bg: '#FFF3E0'
        },
        {
            icon: <MonetizationOn sx={{ fontSize: 32, color: '#9c27b0' }} />,
            label: 'Gastos individuales registrados',
            value: indicators[3]?.value || '0',
            bg: '#F3E5F5'
        },
        {
            icon: <WarningAmber sx={{ fontSize: 32, color: '#d32f2f' }} />,
            label: 'Deuda del mes',
            value: indicators[4]?.value || '0',
            bg: '#FFEBEE'
        },
        {
            icon: <History sx={{ fontSize: 32, color: '#6d4c41' }} />,
            label: 'Deuda del mes anterior',
            value: indicators[5]?.value || '0',
            bg: '#EFEBE9'
        },
        {
            icon: <Paid sx={{ fontSize: 32, color: '#2e7d32' }} />,
            label: 'Total de la rendición',
            value: indicators[6]?.value || '0',
            bg: '#E8F5E9'
        }
    ]

    const onWarning = (rowSelected): void => {
        if (rowSelected?.message_warning) {
            setWarningMessage(rowSelected.message_warning);
        }
    }

    const helperCondition = (rowSelected): void => rowSelected?.message_warning

    return (
        <>
            <Dialog open={open} onClose={closeModal} maxWidth="xl" fullWidth>
                <DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {loading ? (
                        <Grid container justifyContent="center" alignItems="center" style={{ minHeight: 200 }}>
                            <CircularProgress />
                        </Grid>
                    ) : (<>
                        <Grid item container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '10px' }}>
                            <Typography variant='h6' component='h1' gutterBottom sx={{ mt: 1, ml: 1 }} className='title-main'>
                                RENDICIONES DE DEPARTAMENTOS: EDIFICIO PEWEN
                            </Typography>
                        </Grid>

                        {/* <Grid container spacing={2} sx={{ mb: 3 }} style={{ display: "flex", justifyContent: "center" }}>
                        {indicatorCards.map((card, idx) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                                <Card sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    p: 2,
                                    bgcolor: card.bg,
                                    borderRadius: 2,
                                    height: '100%',
                                    boxShadow: 1,
                                }}>
                                    <Box>{card.icon}</Box>
                                    <Box textAlign="right">
                                        <Typography variant="body2" color="text.secondary">
                                            {card.label}
                                        </Typography>
                                        <Typography variant="h6" fontWeight="bold">
                                            {card.value}
                                        </Typography>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid> */}

                        <Grid item xs={12}>
                            <CustomTable
                                columns={columns}
                                rows={formattedData}
                                onRowClick={() => { }}
                                loading={downloading}
                                hasOptions


                                onHelper={onWarning}
                                icon_helper={<WarningIcon fontSize="small" />}
                                tooltip_helper={"Ver advertencia"}
                                helperCondition={helperCondition}

                                onHelper2={onHelper}
                                icon_helper2={<PictureAsPdfIcon fontSize="small" />}
                                tooltip_helper2={"Ver PDF"}

                                finalRow={finalRow}
                            />
                        </Grid>
                    </>)}
                </DialogContent>
            </Dialog>

            <Dialog
                open={Boolean(warningMessage)}
                onClose={() => setWarningMessage(null)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        border: '1px solid #fdd835',
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        bgcolor: '#fffde7',
                        color: '#f57f17',
                        fontWeight: 600,
                    }}
                >
                    <WarningAmberIcon sx={{ color: '#f57f17' }} />
                    Advertencia
                    <IconButton
                        aria-label="close"
                        onClick={() => setWarningMessage(null)}
                        sx={{ marginLeft: 'auto', color: '#f57f17' }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent
                    dividers
                    sx={{ bgcolor: '#fffde7', paddingY: 3, paddingX: 4 }}
                >
                    <Box
                        sx={{
                            whiteSpace: 'pre-line',
                            fontSize: 15,
                            lineHeight: 1.6,
                            color: '#333',
                        }}
                    >
                        {warningMessage}
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
};
